import { render, staticRenderFns } from "./CateList.vue?vue&type=template&id=29a12058&"
import script from "./CateList.vue?vue&type=script&lang=js&"
export * from "./CateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports